import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const RESIZE_OBSERVER_ERROR_RE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i;
const TOAST_COOLDOWN_MS = 3000;

const isResizeObserverError = (value) => RESIZE_OBSERVER_ERROR_RE.test(String(value || ''));

export default function GlobalRuntimeErrorHandler() {
  const lastToastAtRef = useRef(0);

  useEffect(() => {
    const notify = () => {
      const now = Date.now();
      if (now - lastToastAtRef.current < TOAST_COOLDOWN_MS) return;
      lastToastAtRef.current = now;
      toast.error('Unexpected error occurred. Please refresh the page.');
    };

    const onError = (event) => {
      const message = event?.error?.message || event?.message || '';
      if (isResizeObserverError(message)) return;
      console.error('Uncaught runtime error:', event?.error || event);
      notify();
    };

    const onUnhandledRejection = (event) => {
      const message = event?.reason?.message || event?.reason || '';
      if (isResizeObserverError(message)) return;
      console.error('Unhandled promise rejection:', event?.reason || event);
      notify();
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandledRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return null;
}
